import React, { useState, useEffect } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import tableIcons from './tableIcons';
import VisibilityIcon from '@material-ui/icons/RemoveRedEyeOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import CustomDatePicker from "./customDatePicker";
import Itempayments from '../../../components/Payments/Itempayments';
import API from '../../../utils/api';
import { CsvBuilder } from 'filefy';
import moment from 'moment';
import "./TableStyle.css"
import { useDispatch, useSelector } from 'react-redux';

const getActions = {
  view: (action) => ({
    icon: () => <VisibilityIcon color="secondary" fontSize="small" />,
    tooltip: 'View',
    onClick: (event, rowData) => { action(rowData) }
  }),
  delete: (action) => ({
    icon: () => <DeleteOutlineIcon color="secondary" fontSize="small" />,
    tooltip: 'Delete',
    onClick: (event, rowData) => action(rowData)
  }),
  edit: (action) => ({
    icon: () => <EditOutlinedIcon color="secondary" fontSize="small" />,
    tooltip: 'Edit',
    onClick: (event, rowData) => action(rowData)
  })
}

const Table = ({
  classes,
  url,
  onPageChange,
  isLoading = false,
  title = "",
  tableConfig,
  data,
  onView,
  onDelete,
  onEdit,
  onVerify,
  noBorder = false,
  globalSearch = false,
  filtering = true,
  key,
  apidata,
  countryid,
  btnlabel,
  detailPanel,
  exportAllData = false,
  exportCsv = () => { },
  exportFileName = title || "",
}) => {

  const [config, setConfig] = useState([]);
  const [localization, setLocale] = useState({});
  const [pageSize, setPageSize] = useState(20);

  const { totalCounts } = useSelector((state) => state.login)
  const dispatch = useDispatch()

  let actions = [];
  if (onView) {
    actions = [...actions, getActions.view(onView)];
  }
  if (onEdit) {
    actions = [...actions, getActions.edit(onEdit)];
  }
  if (onDelete) {
    actions = [...actions, getActions.delete(onDelete)];
  }


  const filterComponent = (props) => {
    return (<div>
      <input type="text" placeholder="Search" className={classes.filter} onChange={
        (e) => props.onFilterChanged(props.columnDef.tableData.id, e.target.value)
      } /></div>)
  };

  useEffect(() => {
    if (tableConfig && tableConfig.columns) {
      const configuration = tableConfig.columns.map((configItem) => {
        return {
          ...configItem,
          sorting: configItem.filterAndSearch,
          filtering: configItem.filterAndSearch,
          CustomDatePicker: CustomDatePicker,
          filterPlaceholder: 'Search',
          searchable: configItem.filterAndSearch
        }
      });
      setConfig(configuration);
    }
  }, [tableConfig]);


  const setFullfillmentStatus = (statusText) => {
    if (!statusText) {
      return statusText
    }

    statusText = statusText.toString().toLowerCase().replace('_', " ")
    return statusText[0].toUpperCase() + statusText.slice(1, statusText.length)
  }

  return (
    <MaterialTable
      style={{
        width: '100%',
        boxShadow: 'none',
        background: 'white',
        padding: '15px',
        borderRadius: noBorder ? '0px' : '5px'
      }}
      localization={localization}
      icons={tableIcons}
      actions={actions}
      columns={config}
      //data={data}
      title={title}
      isLoading={isLoading}

      options={
        {
          // toolbar: globalSearch,
          filtering: filtering,
          //search:false,
          //exportAllData: true,
          //columnsButton: false,
          //exportButton: true,
          sorting: true,
          hideFilterIcons: true,
          actionsColumnIndex: -1,
          tableLayout: 'fixed',
          searchFieldAlignment: 'left',
          pageSize: pageSize,
          paginationType: 'stepped',
          pageSizeOptions: [10, 20, 40],
          headerStyle: {
            backgroundColor: '#f58634',
            color: 'white',
            padding: '8px 0 8px 16px',
            width: 50,
            position: "sticky",
            top: "0"
          },
          maxBodyHeight: "calc(100vh - 357px)",
          filterCellStyle: {
            backgroundColor: '#fef3ea',
            padding: '8px 0 8px 16px',
          },
          searchFieldStyle: {
            borderRadius: '20px',
            border: '1px solid grey',
            padding: '5px 35px',
            marginBottom: '10px',
            display: 'none'
          },
          exportAllData: true,
          exportButton: true,

          exportCsv: (columns, data) => {
            const columnTitles = columns.map(columnDef => columnDef.title);
            const csvExportData = []
            const orderFileds = [
              { name: 'invoice_id', subField: "" },
              { name: 'order', subField: "delivery_task_id" },
              { name: 'order', subField: "food_seller", subField2: "business_name" },
              { name: 'order', subField: "food_seller", subField2: "seller_type" },
              { name: 'order', subField: "food_seller", subField2: "user", subField3: "name" },
              { name: 'order', subField: "food_seller", subField2: "address_line1" },
              { name: 'order', subField: "food_seller", subField2: "pin_code" },
              { name: 'order', subField: "food_buyer", subField2: "user", subField3: "name" },
              { name: 'order', subField: "food_buyer", subField2: "user", subField3: "address_line1" },
              { name: 'date_system', subField: "" },
              { name: 'order', subField: "delivery_option", subField2: "option_name" },
              { name: 'method', subField: "" },
              { name: 'order', subField: "amount" },
              { name: 'order', subField: "delivery_charges" },
              { name: 'order', subField: "tax" },
              { name: 'amount', subField: "" },
              { name: 'payment_status', subField: "" }
            ]

            data.forEach(payment => {
              const ordersDataDetails = []
              const orderData = orderFileds.map((orderFiled) => {
                let orderValue = payment[orderFiled.name]

                if (orderFiled.subField && orderValue) {
                  orderValue = payment[orderFiled.name][orderFiled.subField]

                  if (orderFiled.subField2 && orderValue) {
                    orderValue = payment[orderFiled.name][orderFiled.subField][orderFiled.subField2]

                    if (orderFiled.subField3 && orderValue) {
                      orderValue = payment[orderFiled.name][orderFiled.subField][orderFiled.subField2][orderFiled.subField3]
                    }
                  }
                }

                if (orderFiled.name === "date_system") {
                  return moment.utc(orderValue).local().format("DD-MM-YYYY h:mm:ss a")
                }


                return orderValue
              })

              ordersDataDetails.push(orderData)

              if (payment.order && payment.order.order_items && payment.order.order_items.length > 0) {
                const fulfillmentStatus = setFullfillmentStatus(payment.order && payment.order.fulfillment_status)
                const orderItemsColumns = [
                  '',
                  'Dish Name',
                  'Dish Category',
                  'Dish Weight',
                  'Quantity',
                  'Amount',
                  'Total Amount',
                  'Fulfillment Status',
                ]
                const orderItemsFileds = [
                  { name: 'item_name', subField: "" },
                  { name: 'food_item', subField: "category", subField2: "category_name" },
                  { name: 'weight', subField: "", subField2: "" },
                  { name: 'quantity', subField: "", subField2: "" },
                  { name: 'amount', subField: "", subField2: "" },
                  { name: 'net_amount', subField: "" },
                  { name: 'fulfillment_status', subField: "" }
                ]

                const ordersItems = payment.order.order_items.map(orderItem => {
                  const ordersItemDetails = ['']
                  const orderItemData = orderItemsFileds.map((orderFiled) => {
                    let orderValue = orderItem[orderFiled.name]
                    if (orderFiled.subField && orderValue) {
                      orderValue = orderItem[orderFiled.name][orderFiled.subField]

                      if (orderFiled.subField2 && orderValue) {
                        orderValue = orderItem[orderFiled.name][orderFiled.subField][orderFiled.subField2]
                      }
                    }

                    if (orderFiled.name === 'fulfillment_status') {
                      return fulfillmentStatus
                    }

                    return orderValue
                  })

                  ordersItemDetails.push(...orderItemData)
                  return ordersItemDetails
                })

                ordersDataDetails.push(orderItemsColumns)
                ordersDataDetails.push(...(ordersItems || []))
              }

              csvExportData.push(...(ordersDataDetails || []))
            })

            const builder = new CsvBuilder(`payments.csv`)
              .setColumns(columnTitles)
              .addRows(csvExportData);

            builder.exportFile()
            return builder;
          },
          exportFileName: "payments"
        }
      }

      data={
        url ? query =>
          new Promise((resolve, reject) => {
            //console.log("apiquery",query);
            setLocale({ body: { emptyDataSourceMessage: '' } });
            let filters = [];

            setPageSize(query.pageSize || 20)
            let painationProps = [`recordsPerPage=${query.pageSize || 20}`, `pageNo=${query.page + 1}`];

            if (query.filters.length > 0) {
              //console.log("filters",query.filters);

              filters = query.filters.map(filter => `${filter.column.field}=${filter.value}`);
            }
            let apiUrl = `${url}&`;
            let newdata = "";

            apiUrl += [...filters, ...painationProps].join('&');
            //console.log("apiurl",apiUrl);
            API.get(apiUrl)
              .then(response => {
                let result = response.data || {};
                if (apidata === "payments") {
                  newdata = result.ResponseData.data

                  dispatch({
                    type: "TOTAL_COUNTS",
                    payload: {
                      ...totalCounts,
                      payments: result.ResponseData.totalCount
                    }
                  });
                }

                resolve({
                  data: newdata,
                  page: query.page,
                  totalCount: result.ResponseData.totalCount,

                })
                setLocale({ body: { emptyDataSourceMessage: isLoading ? '' : 'No Records found' } });
              })
          }) : data
      }
      detailPanel={rowData => {
        return (
          <div>
            <Itempayments orderId={rowData.order_id} orderData={rowData} />
          </div>
        )
      }}
      onRowClick={(event, rowData, togglePanel) => togglePanel()}
    />
  );
};

export default Table;
